/* eslint-disable import/no-webpack-loader-syntax */
const vars = require('../../scripts/sass2js!./eb-variables.scss');

export const rgba = (name, alpha) => {
  const style = vars[name];

  if (style.type !== 'SassColor') {
    return '';
  }

  const { r, g, b } = style.value;

  return `rgba(${r}, ${g}, ${b}, ${alpha})`;
};

const format = ({ type, value, unit = '' }) => {
  switch (type) {
    case 'SassNumber':
      return `${value}${unit}`;
    case 'SassColor':
      return value.hex;
    case 'SassString':
      return value;
    case 'SassList':
      return value.map(format).join(' ');
    default:
      return '';
  }
};

export default (name) => {
  const style = vars[name] || {};

  return format(style);
};
